const REF_YEAR = 2000;
const REF_MONTH = 0; // January — stable, no DST transition in most zones for mid-month refs
const REF_SUNDAY_UTC = 2; // 2000-01-02 is Sunday

function parseIntSafe(value, fallback = 0) {
  const n = parseInt(value, 10);
  return Number.isNaN(n) ? fallback : n;
}

export function utcCronToLocal(cronHour, cronMinute) {
  const hour = parseIntSafe(cronHour);
  const minute = parseIntSafe(cronMinute);
  const date = new Date(Date.UTC(REF_YEAR, REF_MONTH, 1, hour, minute, 0, 0));
  return { hour: date.getHours(), minute: date.getMinutes() };
}

export function localToUtcCron(hour, minute) {
  const localHour = parseIntSafe(hour);
  const localMinute = parseIntSafe(minute);
  const date = new Date(REF_YEAR, REF_MONTH, 1, localHour, localMinute, 0, 0);
  return { cron_hour: date.getUTCHours(), cron_minute: date.getUTCMinutes() };
}

function utcWeekdayDate(dayOfWeek, hour, minute) {
  const date = new Date(Date.UTC(REF_YEAR, REF_MONTH, REF_SUNDAY_UTC, 0, 0, 0, 0));
  const diff = (parseIntSafe(dayOfWeek) - date.getUTCDay() + 7) % 7;
  date.setUTCDate(date.getUTCDate() + diff);
  date.setUTCHours(parseIntSafe(hour), parseIntSafe(minute), 0, 0);
  return date;
}

function localWeekdayDate(dayOfWeek, hour, minute) {
  const date = new Date(REF_YEAR, REF_MONTH, REF_SUNDAY_UTC, 0, 0, 0, 0);
  const diff = (parseIntSafe(dayOfWeek) - date.getDay() + 7) % 7;
  date.setDate(date.getDate() + diff);
  date.setHours(parseIntSafe(hour), parseIntSafe(minute), 0, 0);
  return date;
}

export function utcCronScheduleToLocal({ hour, minute, dayOfWeek, dayOfMonth }) {
  if (dayOfWeek !== undefined && dayOfWeek !== null && dayOfWeek !== '*') {
    const date = utcWeekdayDate(dayOfWeek, hour, minute);
    return {
      hour: date.getHours(),
      minute: date.getMinutes(),
      dayOfWeek: date.getDay(),
    };
  }

  if (dayOfMonth !== undefined && dayOfMonth !== null && dayOfMonth !== '*') {
    const date = new Date(
      Date.UTC(REF_YEAR, REF_MONTH, parseIntSafe(dayOfMonth, 1), parseIntSafe(hour), parseIntSafe(minute), 0, 0)
    );
    return {
      hour: date.getHours(),
      minute: date.getMinutes(),
      dayOfMonth: date.getDate(),
    };
  }

  return utcCronToLocal(hour, minute);
}

export function localScheduleToUtcCron({ hour, minute, dayOfWeek, dayOfMonth }) {
  if (dayOfWeek !== undefined && dayOfWeek !== null && dayOfWeek !== '*') {
    const date = localWeekdayDate(dayOfWeek, hour, minute);
    return {
      cron_hour: date.getUTCHours(),
      cron_minute: date.getUTCMinutes(),
      cron_day_of_week: date.getUTCDay(),
    };
  }

  if (dayOfMonth !== undefined && dayOfMonth !== null && dayOfMonth !== '*') {
    const date = new Date(
      REF_YEAR,
      REF_MONTH,
      parseIntSafe(dayOfMonth, 1),
      parseIntSafe(hour),
      parseIntSafe(minute),
      0,
      0
    );
    return {
      cron_hour: date.getUTCHours(),
      cron_minute: date.getUTCMinutes(),
      cron_day_of_month: date.getUTCDate(),
    };
  }

  return localToUtcCron(hour, minute);
}

export function formatLocalTime(hour, minute, t) {
  const h = parseIntSafe(hour);
  const m = parseIntSafe(minute);
  let displayHour;
  let period;

  if (h === 0) {
    displayHour = 12;
    period = t('general.am');
  } else if (h === 12) {
    displayHour = 12;
    period = t('general.pm');
  } else if (h > 12) {
    displayHour = h - 12;
    period = t('general.pm');
  } else {
    displayHour = h;
    period = t('general.am');
  }

  return `${displayHour}:${String(m).padStart(2, '0')} ${period}`;
}
